var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeaWave4(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1905 187",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1905 46c-22 5-45 7-72 7-118 0-126-46-219-46-94 0-189 46-263 46-17 0-127-52-217-52-185 0-223 50-325 49-50-15-93-49-190-49-124 0-174 52-291 52C210 53 202 7 109 7 72 7 36 14 0 23v164h1905V46z",
    fill: "#239FAF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47 13a507 507 0 0198 1l30 8 29 11a336 336 0 0064 18l34 2C209 46 195 7 109 7c-21 0-42 2-62 6zM496 20a1116 1116 0 0173-12 483 483 0 01144 10l34 10 17 6 8 3 9 3C741 23 697 1 619 1c-50 0-88 9-123 19zM1514 20l8-1 8-1 16-2a586 586 0 0163-5h4l4 1h16l4 1h3c21 2 40 8 59 15l30 11 7 2 4 1 4 1 8 1 8 2c-55-14-77-39-146-39-34 0-67 6-100 13zM1124 6h22a335 335 0 0166 9c29 6 57 14 86 21a540 540 0 00-352-11l44-8a740 740 0 01134-11z",
    fill: "#69BCB8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeaWave4);
export default __webpack_public_path__ + "static/media/sea-wave-4.b595136b4ee9e384debd289262e2c198.svg";
export { ForwardRef as ReactComponent };